import { isV2Entry } from './shared';
import {
    RecentlyPlayedGame,
    GameKind,
} from './types';

export function migrateLegacyRecentlyPlayedGames(games: number[] | RecentlyPlayedGame[]): RecentlyPlayedGame[] {
    // any because ts was complaining
    return (games as any[]).map((gameEntry: number | RecentlyPlayedGame) => {
        if (isV2Entry(gameEntry)) {
            return {
                id: `${gameEntry}`,
                kind: GameKind.CasinoGeneric,
            };
        } else {
            return gameEntry;
        }
    });
}
